import type { ExternalTableSchema } from '@packages/table-builder';

/** Bakes parent id into GET path (Release `withReleaseIdEndpoint` pattern). */
export function withPlanGrantDocumentId(
  schema: ExternalTableSchema,
  planGrantDocumentId: string,
): ExternalTableSchema {
  return {
    ...schema,
    dataSource: schema.dataSource
      ? {
          ...schema.dataSource,
          endpoint: schema.dataSource.endpoint.replace('{Id}', planGrantDocumentId),
        }
      : schema.dataSource,
  };
}

export const planGrantDocumentTable: ExternalTableSchema = {
  metadata: {
    title: 'Plan Grant Documents',
    entity: 'Plan Grant Document',
  },

  dataSource: {
    endpoint: '/api/award/api/app/plan/plan-grant-document-detail-by-id/{Id}',
    method: 'GET',
    rowIdField: 'id',
    fetchPolicy: 'requireFilter',
    requestParams: {
      Id: 'filters.Id',
    },
    responseMapping: {
      items: 'planGrantDocumentDetails',
    },
    saveActionId: 'SAVE_PLAN_GRANT_DOCUMENT_DETAIL',
    saveMethod: 'PUT',
    saveSuccessMessage: 'Plan Grant Document Edited.',
    onSaveSuccess: 'toastAndRefetch',
  },

  columns: [
    { field: 'createdDate', header: 'Uploaded Time', type: 'date', width: 130 },
    {
      field: 'fileContentName',
      header: 'Document Name',
      type: 'link',
      width: 160,
      link: {
        url: 'api/award/api/app/plan/download-plan-grant-document',
        includeParams: false,
        payloadMapper: [
          { labelKey: 'planId', valueKey: 'planId' },
          { labelKey: 'id', valueKey: 'id' },
        ],
      },
    },
    {
      field: 'effectiveDate',
      header: 'Effective Date',
      type: 'date',
      width: 130,
      editable: { type: 'date', placeholder: 'MM/DD/YYYY' },
    },
    {
      field: 'isActive',
      header: 'Status',
      type: 'badge',
      width: 120,
      align: 'center',
      conditionalValues: { true: 'ACTIVE', false: 'INACTIVE' },
      badge: { statusMap: { ACTIVE: 'success', INACTIVE: 'error' } },
      editable: { type: 'asyncSelect' },
      dataSource: {
        url: '/api/award/api/app/status-dropdown-app-services/active-status',
        mapper: { label: 'name', value: 'value' },
      },
    },
  ],

  actions: {
    toolbar: {
      primary: { id: 'ADD_DOCUMENT_DETAIL_PLAN_GRANT_DOCUMENT', label: 'Add Document' },
    },
    row: [
      { id: 'EDIT_PLAN_GRANT_DOCUMENT', label: 'Edit', actionType: 'startEditing' },
      { id: 'DELETE_PLAN_GRANT_DOCUMENT', label: 'Delete', variant: 'danger' },
    ],
  },

  features: {
    search: { enabled: false },
    pagination: { mode: 'infiniteScroll', defaultSize: 10 },
    editing: { bulkSave: false },
    layout: { noPadding: true },
    columnPreferences: {
      persistenceKey: 'PlanGrantDocumentVersions',
      resizable: true,
      reorderable: true,
    },
  },
};
